/**
 * ドロワー内アコーディオン機能
 */
const drawerAccordion = () => {
  const accordionItems = document.querySelectorAll('.js-drawer-accordion');
  const activeClass = 'is-active';

  accordionItems.forEach((item) => {
    const trigger = item.querySelector('.m-drawer__trigger');
    const sublist = item.querySelector('.m-drawer__sublist');

    if (!trigger || !sublist) return;

    trigger.addEventListener('click', () => {
      const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

      // aria属性の切り替え
      trigger.setAttribute('aria-expanded', !isExpanded);
      sublist.setAttribute('aria-hidden', isExpanded);

      // クラスの切り替え
      item.classList.toggle(activeClass, !isExpanded);
    });
  });
};

export { drawerAccordion };
